import React from "react";
import { Navigate, Routes, Route ,useLocation} from "react-router-dom";
import { GuestLayout } from "./GuestLayout";
import { PrivateLayout } from "./PrivateLayout";
import { PAGE_URL, USER_ROLES } from "../utils";
import { useAuthorization, useAuthUser } from "../hooks";
import * as Pages from "../pages";
import { RedirectLayout } from "./RedirectLayout";

export const AppRoutes = () => {
  const { roleName } = useAuthUser();
  return (
    <Routes location={location}>
      <Route element={<PrivateLayout />}>
        <Route path={PAGE_URL.DOCUMENTS} element={<Pages.Documents />} />
        <Route path={`${PAGE_URL.DOCUMENT}/:documentUuid?`} element={<Pages.Document />} />
        <Route path={`${PAGE_URL.STATUS}/`} element={<Pages.Status />} />
        <Route path={PAGE_URL.SETTINGS} element={<Pages.Settings />} />
        <Route path={PAGE_URL.FEEDBACK} element={<Pages.Feedback />} />
        <Route path={PAGE_URL.FEEDBACKS} element={<Pages.Feedbacks />} />
        <Route
          path={PAGE_URL.OTHERS}
          element={
            roleName === USER_ROLES.SUPER_ADMIN ? (
              <Pages.Others />
            ) : (
              <Navigate to={PAGE_URL.STATUS} replace />
            )
          }
        />
      </Route>
      <Route element={<GuestLayout />}>
        <Route path={PAGE_URL.LOGIN} element={<Pages.Login />} />
      </Route>
      <Route element={<RedirectLayout />}>
        <Route path={PAGE_URL.REDIRECTION} element={<Pages.Redirect />} />
      </Route>
    </Routes>
  );
};
